<div class="alert alert-info">
	{{TR "Regelmäßige Übertragung von Wetterdaten basierend auf dem Gerätestandort."}}
</div>
